import * as React from 'react';
import './ExpandableMobile.scss';

import ReactToPrint from 'react-to-print';
import ExpandableRowMobile from '../ExpandableRowMobile';
import localeFormatingInstance from 'src/translation/localeFormating';
import Button from 'src/components/common/Button';
import { IReturnDetail, IStatusItem } from 'src/services/returns/typings';
import {
  RMA_EDIT,
  RMA_SUBMIT,
  IRmaModalData
} from 'src/pages/ReturnsView/ReturnsView';
import ContentToPrint from '../../../ContentToPrint';
import { ERmaStatus } from '../../StatusTab';
import ShippingLabelToPrint from '../../../ShippingLabelToPrint';
import CaShippingLabelWIndow from '../CaShippingLabelWIndow';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';

interface IExpandableMobileProps {
  statusData: IStatusItem;
  handleShowRmaModal: (state: boolean, rmaModalData: IRmaModalData) => void;
  setSelectedReturnToDelete: (id: string) => void;
  isDownloadingPdf: boolean;
  downloadPdf: (rmaNumber: string, isPrepaidLabel: string) => void;
  clearEligibleFilters: () => void;
  t?: any;
}

const calculateResult = (returnDetails: IReturnDetail[]): number => {
  let result = 0;

  returnDetails.forEach(r => {
    result += r.returnAmount;
  });

  return result;
};

const ExpandableMobile: React.FC<IExpandableMobileProps> = props => {
  const componentRef = React.useRef();
  const componentShippingRef = React.useRef();
  const [isDownloadingDetails, setIsDownloadinDetails] = React.useState<
    boolean
  >(false);
  const [documentTitle, setDocumentTitle] = React.useState<string>('');
  const [isShippingDownloadingDetails, setIsShippingDownloadingDetails] = React.useState<boolean>(false);
  const [cAPrintLabelReady, setCaPrintLabelReady] = React.useState<boolean>(false);
  const [isLoadingBarcode, setisLoadingBarcode] = React.useState<boolean>(false);
  const {
    statusData,
    handleShowRmaModal,
    setSelectedReturnToDelete,
    isDownloadingPdf,
    downloadPdf,
    clearEligibleFilters,
    t
  } = props;

  const handleOpenSlide = (action: string) => {
    handleShowRmaModal(true, {
      action,
      data: statusData.returnDetails,
      rmaNumber: statusData.rmaNumber,
      poNumber: statusData.rmaNumber
    });
  };

  const getCaPrintingLabel = () => {
    setisLoadingBarcode(false);
    setCaPrintLabelReady(true);
  };

  const rePrintBarcode = (rmaBarcodeNo: string, shipmentType: string) => {
    if(shipmentType==="PREPAID_SHIPPING"){
      downloadPdf(rmaBarcodeNo,'yes');
    }else{
      downloadPdf(rmaBarcodeNo,'no'); 
    }
  };
  const closeWindowPortal = () => {
    setCaPrintLabelReady(false);
   };
   const getShippingTypeStatus = (rawTxt: string) => {
    switch (rawTxt?.toLowerCase()) {
      case 'drop_off_store':
        return t('myReturns.dropOffStoreText');
      case 'self_shipping':
        return t('myReturns.selfShippingText');
      case 'prepaid_shipping':
        return t('myReturns.prepaidShippingText');
      default:
        return rawTxt;
    }
  };
  const getRmaStatusType = (rStatus: string, rButtonName: string, shippingType: string) => {
    switch (rStatus) {
        case 'IN PROGRESS':
          return 'NO';
          break;
        case 'NOT SUBMITTED':
          return 'YES';
          break;
        case 'CANCELLED':
          return 'NO';
          break;
        case 'PARTIALLY_CANCELLED':
          return 'NO'
          break;
        case 'COMPLETED':
          return 'NO'
          break;  
        default:
          return 'NO'
    }
};
  return (
    <div className="rp-expandable-mobile">
      <div style={{ display: 'none' }}>
        <ContentToPrint
          ref={componentRef}
          total={calculateResult(statusData.returnDetails)}
          statusData={statusData}
        />
      </div>
      <div style={{ display: 'none' }}>
        <ShippingLabelToPrint
          ref={componentShippingRef}
          shippingLabel={statusData.shippingLabelUrls}
        />
      </div>
      {cAPrintLabelReady &&
        <CaShippingLabelWIndow 
        closeWindowPortal={closeWindowPortal}
        >
            {statusData.shippingLabelUrls.map((img: any, index: number) =>
                <div className="rp-content-to-print-row" key={index}> 
                <div className="container-fluid">
                      <p className="rp-content-to-print-row-content quantity text-center">
                      <object data={img} type="application/pdf" style={{width: "100%",height: "100%"}} >
                      <embed src={img} type="application/pdf" style={{width: "100%",height: "100%"}} />
                      </object> 
                      </p>
                </div>
              </div>
              )}
        </CaShippingLabelWIndow>
        }
      <div className="container-fluid">
        <div className="row rp-expandable-mobile-options-wrapper">
          <div className="col-3">
            <p className="rp-expandable-mobile-option-title">
              {t('accountCreditCards.tableActions')}
            </p>
          </div>
          <div className="col-9 rp-expandable-mobile-options">
              {getRmaStatusType(statusData.status,"EDIT",statusData.shipmentType)==="YES" && 
              (
                <i
                  onClick={() => handleOpenSlide(RMA_EDIT)}
                  className="rpds-edit rp-expandable-mobile-option-edit"
                />
              )}
              
              {getRmaStatusType(statusData.status,"DELETE",statusData.shipmentType)==="YES" && 
              (
                <i
                  className="rpds-trash rp-expandable-mobile-option-remove"
                  onClick={() => {
                    setSelectedReturnToDelete(statusData.rmaNumber);
                    clearEligibleFilters();
                  }}
                />
              )}
             

            {statusData.status === ERmaStatus.IN_PROGRESS && (
              <i
                onClick={() => rePrintBarcode(statusData.rmaNumber, statusData.shipmentType)}
                className="rpds-barcode rp-expandable-mobile-option-barcode"
              />
            )}

            <ReactToPrint
              onBeforeGetContent={() => {
                setDocumentTitle(document.title);
                document.title = `${
                  statusData.rmaNumber
                }-${localeFormatingInstance.getNowDate('short')}.pdf`;
                setIsDownloadinDetails(true);
                setCaPrintLabelReady(false);
              }}
              onAfterPrint={() => {
                document.title = documentTitle;
                setIsDownloadinDetails(false);
                setCaPrintLabelReady(false);
              }}
              trigger={() =>
                isDownloadingDetails ? (
                  <div className="loadingio-spinner-rolling-x8i9qka9tdm">
                    <div className="ldio-9coovtt1mti">
                      <div />
                    </div>
                  </div>
                ) : (
                 <button
                          className="print-button"
                          >
                            <p>{t('myReturns.printDetails')}</p>
                            </button>
                )
              }
              content={() => componentRef.current}
            />

{isShippingDownloadingDetails && (
              <div className="rp-expandable-desktop-loading">
                <div className="loadingio-spinner-rolling-x8i9qka9tdm">
                  <div className="ldio-9coovtt1mti">
                    <div />
                  </div>
                </div>
              </div>
            )} 
           {/* Shipping Label Print */} 
           {statusData.shippingLabelUrls && env.REACT_APP_BASE_ENVIRONMENT === 'US' &&   
            <ReactToPrint
              onBeforeGetContent={() => {
                setDocumentTitle(document.title);
                document.title = `${
                  statusData.rmaNumber
                }-${localeFormatingInstance.getNowDate('short')}.pdf`;
                setIsShippingDownloadingDetails(true);
              }}
              onAfterPrint={() => {
                document.title = documentTitle;
                setIsShippingDownloadingDetails(false);
              }}
              trigger={() => (
                <button style={{ marginLeft: "3px"}} 
                 className={`print-button ${isShippingDownloadingDetails &&
                    'disabled'}`}
                >
                  <p>{t('myReturns.printShippingLabel')}</p>
                </button>
              )}
              content={() => componentShippingRef.current}
              documentTitle={`${
                statusData.rmaNumber
              }-${'Shipping-Label'
              }-${localeFormatingInstance.getNowDate('short')}.pdf`}
            />
            }   
             &nbsp; 
             {statusData.shippingLabelUrls && env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
                    <div className="rp-expandable-mobile-option-print">
                        <button
                          className="print-button"
                          onClick={() => getCaPrintingLabel()}
                          >
                            <p>{t('myReturns.printShippingLabel')}</p>
                            </button>
                      
                    </div>
                    }
          </div>
        </div>
      </div>
      {statusData.returnDetails.map(returnDetail => (
        <ExpandableRowMobile
          key={returnDetail.id}
          returnDetail={returnDetail}
        />
      ))}
      <div className="container-fluid">
      {statusData.shippingCharges >0 &&   
      <div className="row">
          <div className="col-12 rp-expandable-mobile-total">
            <p className="rp-expandable-mobile-estimated">
            {t('myReturns.shippingCharges')}
            </p>
            <p className='greenText'>
              {localeFormatingInstance.formatCurrency(statusData.shippingCharges)}
            </p>
          </div>
        </div>
        }
        {statusData.shipmentType!==null &&
        <div className="row">
          <div className="col-12 rp-expandable-mobile-total">
            <p className="rp-expandable-mobile-estimated">
             {t('myReturns.shippingType')}
            </p>
            <p className='greenText'>
              {getShippingTypeStatus(statusData.shipmentType)}
            </p>
          </div>
        </div>
        }
       {statusData?.trackingNumbers!==null && statusData?.trackingNumbers.length >0 &&
        <div className="row">
          <div className="col-12 rp-expandable-mobile-total">
            <p className="rp-expandable-mobile-estimated">
             {t('myReturns.trackingNumber')}
            </p>
            <p className='greenText'>
              {statusData.trackingNumbers.map((trackingNumbers, index) => (
                <span key={index}>{trackingNumbers} &nbsp;</span>
              ))}
            </p>
          </div>
        </div>
        }
        <div className="row">
          <div className="col-12 rp-expandable-mobile-total">
            <p className="rp-expandable-mobile-estimated">
              {`${t('common.totalCapsTxt')} ${
                statusData.status !== ERmaStatus.COMPLETED
                  ? `${t('common.estimated')}`
                  : ''
              } ${t('common.credit')}`}
            </p>
            <p className='greenText'>
              {localeFormatingInstance.formatCurrency(statusData.returnTotal)}
            </p>
          </div>
        </div>
      </div>
          {getRmaStatusType(statusData.status,"RESUBMIT",statusData.shipmentType)==="YES" && (
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <Button
                  action={() => {
                    handleOpenSlide(RMA_SUBMIT);
                    clearEligibleFilters();
                  }}
                  label={t('myReturns.submitReturn')}
                  textTransform="uppercase"
                  buttonClass="rp-expandable-mobile-submit"
                />
              </div>
            </div>
          </div>
          )}
    </div>
  );
};

export default ExpandableMobile;
